export default __webpack_public_path__ + "static/media/4632.f37953f5.png";